<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row v-if="tstatus == true">
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout
            :headertext="$t('Customer.CustomerMaster.List')"
            :contenttext="$t('Customer.CustomerMaster.content')"
          >
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty
              v-if="items.length === 0 && !loading"
              eheader="Customers Master"
              econtent="Customer"
              eimg="/src/assets/Img/icons/suppliermaster.svg"
              @createNew="IsCreate"
            />
            <Tableview
              v-if="items.length !== 0"
              :value="items"
              :paginator="true"
              class="p-datatable-gridlines"
              :rows="10"
              :rowHover="true"
              filterDisplay="menu"
              :loading="loading1"
              responsiveLayout="scroll"
              :columns="headers"
              :globalFilterFields="globalFilterFields"
              :filters="filters"
              selectionMode="single"
              @row-click="RowClick"
              :exceldownload="true"
            >
              <template v-slot:Add>
                <span class="add">
                  <AddButton
                    @click="IsCreate()"
                    :btnname="$t('btn.plusaddnew')"
                    class="float-rights my-3"
                  ></AddButton>
                </span>
              </template>
              <template v-slot:exceldownload>
                <ExportOption
                  @ExportExcel="ExportExcel"
                  @ExportPDF="ExportPDF"
                  :ExportList="ExportList"
                  PageName="Supplier Master"
                  :ExportOption="ExportOption"
                  class="ms-2"
                  :HideAndShow="true"
                />
              </template>
              <template v-slot:Status="{ data }">
                <!-- {{ data.IsActive }} -->
                <!-- <Badge v-if="data.IsActive == '0'" severity="warning">{{
                  "InActive"
                }}</Badge>
                <Badge v-if="data.IsActive == '1'" severity="success">{{
                  "Active"
                }}</Badge> -->
                <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                <GreenStatus name="Active" v-if="data.IsActive == '1'" />

                <!-- <span class="table-status"></span> -->
              </template>
              <template v-slot:action="{ data }">
                <span>
                  <Button
                    icon="pi pi-ellipsis-v"
                    class="p-button-rounded editicon p-button-text"
                    @click="toggle($event, data)"
                  />
                  <!-- <EditIcon @click="Editdata(data)" class="me-3" />
                <DeleteIcon @click="Deletedata(data)" /> -->
                </span>
              </template>
            </Tableview>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty
              v-if="items.length === 0 && !loading"
              eheader="Customers Master"
              econtent="Suppliers"
              eimg="/src/assets/Img/icons/suppliermaster.svg"
              @createNew="IsCreate"
            />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div
                    class="d-flex align-items-center justify-content-between gap-2"
                  >
                    <div>
                      <p class="light-name">{{ item.Code }}</p>
                      <p class="name">{{ item.Name }}</p>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <!-- <Badge v-if="item.IsActive == '0'" severity="warning">{{
        "InActive"
      }}</Badge>
                        <Badge v-if="item.IsActive == '1'" severity="success">{{
        "Active"
      }}</Badge> -->
                        <OrangeStatus
                          name="InActive"
                          v-if="item.IsActive == '0'"
                        />
                        <GreenStatus
                          name="Active"
                          v-if="item.IsActive == '1'"
                        />
                      </div>
                      <i
                        class="pi pi-ellipsis-v"
                        @click="toggle($event, item)"
                      ></i>
                    </div>
                  </div>
                  <p class="light-name">{{ item.SupplierCategory }}</p>
                </div>
              </template>
            </MobileViewCardHeader>
            <!-- <div class="d-flex justify-content-center">
                <b-pagination v-model="currentPage" :total-rows="mobilerows" :per-page="perPage" size="md"
                  aria-controls="my-table"></b-pagination>
              </div> -->
          </div>
        </div>
      </b-row>

      <!-- <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
      <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit()" @no="Editmodel = false" :content="$t('confirmation.editcontent')" /> -->
    </b-container>
  </div>
  <!-- Commonly Used Components -->
  <Menu
    ref="menu"
    id="overlay_menu"
    :model="itemListed"
    @click=""
    :popup="true"
  />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsEdit()"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <DeleteConfirmationVue
    :DeleteModel="Deletemodel"
    :content="contentdel"
    @yes="IsDelete(dataEdit)"
    @no="Deletemodel = false"
  />
  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <Toast />
  <!-- Commonly Used Components -->
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, computed, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

import PaymentCreation from "../../../Masters/Supplier/PaymentTerms/PaymentTermsCreation.vue";
import { RouterLink, RouterView, useRouter } from "vue-router";

import service from "../../../../Service/CustomerMaster";
import Table from "../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import CategoryCreation from "../../ItemCategory/CategoryMaster/CategoryCreation.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    PaymentCreation,

    Table,
    CategoryCreation,
    Tableview,
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    Loader,
    MasterEmpty,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  props: {
    tstatus: {
      default: true,
      type: Boolean,
    },
  },
  setup() {
    const items: any = ref([]);
    let objectdata = ref({});
    let InActivevisible = ref();
    let Editvisible = ref();

    let Activevisible = ref();
    let Deletevisible = ref();
    const menu = ref();
    const dataEdit = ref();
    const rowFocus = ref(false);
    const showDialog = ref();
    const toast = useToast();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const router = useRouter();
    const generic = ref();

    let loading1 = ref(false);

    let loading = ref(false);
    let customerid = 0;

    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const contentdel = ref("");

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);

      FunctionRights();

      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
      // window.removeEventListener('popstate', handlePopState);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    async function FunctionRights() {
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    function Editdata(data) {
      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        customerid = data.Id;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = false;
        Deletemodel.value = true;

        data.ActiveStatus = Status;
        if (Status == 1) {
          contentdel.value = t("confirmation.activecontent");
        } else if (Status == 2) {
          contentdel.value = t("confirmation.inactivecontent");
        } else {
          contentdel.value = t("confirmation.deletecontent");
        }
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: { value: null, matchMode: FilterMatchMode.IN, options: items },
      SupplierCategory: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const headers = [
      {
        header: t("Customer.CustomerMaster.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("Customer.CustomerMaster.Code"),
        field: "Code",
        class: "smallwidth",
      },
      {
        header: t("Customer.CustomerMaster.Name"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: t("Customer.CustomerMaster.SupplierCategory"),
        field: "SupplierCategory",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      //   {
      //     header: t("Customer.CustomerMaster.PhoneNumber"),
      //     field: "PhoneNumber",
      //   },
      {
        header: t("Customer.CustomerMaster.Email"),
        field: "Email",
      },
      {
        header: t("Customer.CustomerMaster.Address"),
        field: "Address",
      },
      {
        header: t("Customer.CustomerMaster.Status"),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    let ExportOption = ref("");
    let ExportList = ref([]);

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;
        const response = await service.gettable();
        console.log(response["result"]);
        let count = 0;
        if (usersData.Admin == 1) {
          response["result"] = response["result"]
            .filter((items) => items.HospitalId == usersData.OrganizationId)
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        } else {
          response["result"] = response["result"]
            .filter(
              (items) =>
                items.HospitalId == usersData.OrganizationId &&
                items.BranchId == usersData.BranchId
            )
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        }

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", items.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    const IsCreate = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        router.push({
          path: "/CustomerMasterCreation",
          query: { OperationId: ObjOperationId.value.CreateId },
        });
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };

    function IsEdit() {
      router.push({
        path: "/CustomerMasterCreation",
        query: {
          Id: customerid,
          OperationId: ObjOperationId.value.UpdateId,
        },
      });
    }

    function RowClick(event: any) {
      debugger;

      router.push({
        path: "/CustomerMasterDetailsView",
        query: {
          Id: event.data.Id,
          Type: "customerId",
        },
      });
    }

    async function IsShow() {
      debugger;
      loading.value = true;
      try {
        const response = await service.gettable();
        console.log(response["result"]);
        let count = 0;
        if (usersData.Admin == 1) {
          response["result"] = response["result"]
            .filter((items) => items.HospitalId == usersData.OrganizationId)
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        } else {
          response["result"] = response["result"]
            .filter(
              (items) =>
                items.HospitalId == usersData.OrganizationId &&
                items.BranchId == usersData.BranchId
            )
            .map((item) => {
              item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
              count = count + 1;
              item.RowNumber = count;
              return item;
            });
        }

        items.value = response["result"];
        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsCreate();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit();
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    const MappingPop = ref({
      visible: false,
      content: "",
    });
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    const IsDelete = async (data) => {
      loading.value = true;

      try {
        debugger;

        let result: any = "";
        if (data.ActiveStatus == 0) {
          result = await service.deletedata(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          result = await service.active(data.Id, status);
        }

        let message = result["ErrorInfo"].ErrorCode;

        if (message == null) {
          if (data.ActiveStatus == 1) {
            loading.value = false;
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            loading.value = false;
            pop.value.inactivepop = true;
          } else {
            loading.value = false;
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        alert(error);
      }
    };

    const toggle = (event, data) => {
      debugger;
      console.log(event);
      objectdata.value = data;

      if (data.IsActive == 1) {
        InActivevisible.value = true;
        Activevisible.value = false;
      } else {
        InActivevisible.value = false;
        Activevisible.value = true;
      }

      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: InActivevisible,
            command: async () => {
              Editdata(objectdata.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(objectdata.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 2);
            },
          },
        ],
      },
    ]);

    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }

    return {
      closetrigger,
      dataEdit,
      contentdel,
      pop,
      MappingPop,
      toggle,
      menu,
      itemListed,
      deletepop,
      headers,
      items,
      IsShow,
      IsDelete,
      generic,
      loading1,
      globalFilterFields,
      filters,
      IsCreate,
      IsEdit,
      Editdata,
      Editmodel,
      IsConfirmDel,
      RowClick,
      Deletemodel,
      loading,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>
